import { ArticleParagraph3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { INFRASTRUCTURE_MAP_ICON_MAP } from '../../constants/infrastructureIcons';

export interface IMapBalloonProps {
  title: string;
  description: string;
  type: string;
}

export function MapBalloon({ title, type, description }: IMapBalloonProps) {
  const Icon: React.FunctionComponent<{ color?: string }> | undefined = INFRASTRUCTURE_MAP_ICON_MAP.get(type);

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['balloon']}>
      <div className={styles['icon']}>
        <Icon color={'icon-inverted-default'} />
      </div>
      <div>
        <ArticleParagraph3 as={'span'}>{title}</ArticleParagraph3>
        <ArticleParagraph3 color={'gray60_100'} as={'span'}>
          {description}
        </ArticleParagraph3>
      </div>
    </div>
  );
}
